import React from "react";
import OfferTiers from "./OfferTiers";
import { OFFER_SUMMARY_HI } from "../data/offer";
import { APP_URL } from "../data/site";

/** In-page version of the app offer, shown below the live results table. */
const AppPromo = () => (
  <section className="card app-download-promo" aria-labelledby="app-promo-title">
    <h2 className="app-download-title" id="app-promo-title">
      Bagad Satta App — PRO &amp; MAX अकाउंट
    </h2>

    <OfferTiers />

    <p className="app-download-text">{OFFER_SUMMARY_HI}</p>

    <div className="app-download-buttons">
      <a
        href={APP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="app-download-btn"
      >
        Official App Download
      </a>
    </div>
  </section>
);

export default AppPromo;
